"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseApi = void 0;
const api_error_1 = __importDefault(require("./errors/api_error"));
class BaseApi {
    constructor(url, tokenFetcher, openApiConfig) {
        this.url = url;
        this.tokenFetcher = tokenFetcher;
        this.openApiConfig = openApiConfig;
        /*
            This is an OpenAPI middleware to handle appending credentials to API calls from our CredentialManager.
        */
        this.preApiMiddleware = (context) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            let authorizationValue;
            if (this.shareToken) {
                authorizationValue = `ShareToken ${this.shareToken}`;
            }
            else if (this.apiKey) {
                authorizationValue = `Basic ${btoa(`${this.apiKey.id}:${this.apiKey.secret}`)}`;
            }
            else if (this.adminBearerToken) {
                authorizationValue = `Bearer ${this.adminBearerToken}`;
            }
            else if ((_a = this.tokenFetcher) === null || _a === void 0 ? void 0 : _a.isTokenAvailable()) {
                authorizationValue = `Bearer ${yield this.tokenFetcher.fetchAccessToken()}`;
            }
            if (authorizationValue) {
                const headers = new Headers(context.init.headers);
                headers.set('Authorization', authorizationValue);
                context.init.headers = headers;
            }
            return context;
        });
        /*
            This is a OpenAPI middleware to handle retries if credentials need a refresh and raise API errors.
        */
        this.postApiMiddleware = (context) => __awaiter(this, void 0, void 0, function* () {
            var _b;
            if (context.response.status === 500) {
                throw new api_error_1.default('Internal Server Error', context.response);
            }
            // This is a hack to keep track of retries in the fetch RequestInit.
            const retries = context.init.retries || 0;
            // Skip retry logic for ShareToken and Basic auth.
            const authorizationHeader = this.getHeader(context.init, 'Authorization');
            const hasAuthHeaderWithBearerToken = authorizationHeader && authorizationHeader.startsWith('Bearer');
            // Refresh access token if unauthorized
            if (hasAuthHeaderWithBearerToken &&
                context.response.status === 401 &&
                retries <= 2 &&
                typeof window !== 'undefined') {
                yield ((_b = this.tokenFetcher) === null || _b === void 0 ? void 0 : _b.refreshAccessToken());
                return context.fetch(context.url, this.buildRetryRequestParams(context, retries));
            }
            // Retry with backoff
            if (context.response.status === 429 && retries <= 4) {
                yield this.delay(retries);
                return context.fetch(context.url, this.buildRetryRequestParams(context, retries));
            }
            if (context.response.status === 401 && retries > 2) {
                throw new api_error_1.default('Received 401 even after refreshing OAuth token.', context.response);
            }
            if (context.response.status === 429 && retries > 4) {
                throw new api_error_1.default('Received series of 429 even after backing off', context.response);
            }
            if (context.response.status < 200 || context.response.status >= 400) {
                const responseBody = yield context.response.clone().text();
                throw new api_error_1.default(`Received error.status=${context.response.status} error.responseBody=<${responseBody}> error.url=<${context.response.url}>`, context.response);
            }
            return context.response;
        });
    }
    // Used by Streem's Support App
    setAdminBearerToken(token) {
        this.adminBearerToken = token;
    }
    setShareToken(token) {
        this.shareToken = token;
    }
    setApiKey(id, secret) {
        this.apiKey = {
            id,
            secret,
        };
    }
    get apiConfig() {
        if (!this.url) {
            throw new Error(`Attempted to use ${this.constructor.name} before calling ${this.constructor.name}.configure`);
        }
        return Object.assign(Object.assign({}, (this.openApiConfig || {})), { basePath: this.url, middleware: [
                {
                    pre: this.preApiMiddleware,
                    post: this.postApiMiddleware,
                },
            ] });
    }
    buildRetryRequestParams(context, retries) {
        return Object.assign(context.init, {
            retries: ++retries,
        });
    }
    /**
     * Sleeps program for up to 1 second max.
     */
    delay(retryCount) {
        const timeout = Math.pow(10, retryCount);
        return new Promise(resolve => setTimeout(resolve, timeout > 1000 ? 1000 : timeout));
    }
    getHeader(init, name) {
        const headers = new Headers(init.headers);
        return headers.get(name);
    }
}
exports.BaseApi = BaseApi;
//# sourceMappingURL=base_api.js.map